import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Footer() {
  const location = useLocation();
  // Hide footer on preview page — zero distractions, focus on purchase
  if (location.pathname.startsWith("/preview/")) return null;

  return (
    <footer
      className="w-full border-t border-white/10"
      style={{ backgroundColor: "var(--color-navy)" }}
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <span className="font-heading text-2xl tracking-wider text-white">
              CARD MY <span style={{ color: "var(--color-gold)" }}>DOG</span>
            </span>
            <p className="text-white/50 font-body text-sm mt-3 leading-relaxed">
              Your dog. A legend. Turn your best friend into a professional
              sports trading card.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="font-heading text-white tracking-widest uppercase text-sm mb-4">Product</h4>
            <div className="flex flex-col gap-2">
              <Link to="/create" className="text-white/50 hover:text-white font-body text-sm transition-colors">Create a Card</Link>
              <Link to="/faq" className="text-white/50 hover:text-white font-body text-sm transition-colors">FAQ</Link>
              <Link to="/contact" className="text-white/50 hover:text-white font-body text-sm transition-colors">Contact</Link>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading text-white tracking-widest uppercase text-sm mb-4">Legal</h4>
            <div className="flex flex-col gap-2">
              <Link to="/privacy" className="text-white/50 hover:text-white font-body text-sm transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="text-white/50 hover:text-white font-body text-sm transition-colors">Terms of Service</Link>
            </div>
          </div>

          {/* Account */}
          <div>
            <h4 className="font-heading text-white tracking-widest uppercase text-sm mb-4">Account</h4>
            <div className="flex flex-col gap-2">
              <Link to="/login" className="text-white/50 hover:text-white font-body text-sm transition-colors">Sign In</Link>
              <Link to="/signup" className="text-white/50 hover:text-white font-body text-sm transition-colors">Create Account</Link>
              <Link to="/account" className="text-white/50 hover:text-white font-body text-sm transition-colors">My Cards</Link>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/30 font-body text-xs">
            &copy; {new Date().getFullYear()} Card My Dog. All rights reserved.
          </p>
          <p className="text-white/30 font-body text-xs">
            No real sports teams or leagues are affiliated with Card My Dog. All designs are original.
          </p>
        </div>
      </div>
    </footer>
  );
}
